import { apiUrl } from "./api";

/**
 * A trainer's public profile — the face on a cohort's card (16.10.2026).
 * The server keeps the rules (`services/trainer_profile.py`): nothing is
 * published without the trainer's agreement and the switch.
 */
export const LIMITS = { display_name: 80, title: 80, bio: 600 };
export const PHOTO_ACCEPT = "image/jpeg,image/png,image/webp";
export const PHOTO_MAX_BYTES = 8 * 1024 * 1024;

/** The API gives "/api/public/trainers/photo/<id>.webp"; the site is on another host. */
export function photoSrc(url) {
  if (!url) return null;
  return /^https?:\/\//.test(url) ? url : apiUrl(String(url).replace(/^\/?api\//, ""));
}

/** The admin's own copy, shown whether or not the profile is published. */
export const adminPhotoSrc = (photoId) => (photoId ? apiUrl(`/admin/trainers/photo/${photoId}.webp`) : null);

export function profileOf(trainer) {
  return trainer?.public_profile || {};
}

export function isPublic(trainer) {
  const p = profileOf(trainer);
  return Boolean(p.enabled && p.consent?.at) && trainer?.active !== false;
}

/** "Acord bifat pe 16 octombrie 2026, de ana@fped.org." */
export function consentLine(consent) {
  if (!consent?.at) return "";
  const day = new Intl.DateTimeFormat("ro-RO", { timeZone: "Europe/Bucharest", day: "numeric", month: "long",
    year: "numeric" }).format(new Date(consent.at));
  return `Acord bifat pe ${day}${consent.by ? `, de ${consent.by}` : ""}.`;
}

export const left = (text, max) => max - String(text || "").length;

/** What the photo picker refuses before it uploads anything. */
export function photoProblem(file) {
  if (!file) return "";
  if (!PHOTO_ACCEPT.split(",").includes(file.type)) return "Merg doar poze JPG, PNG și WebP.";
  if (file.size > PHOTO_MAX_BYTES) return "Poza are peste 8 MB. Alege una mai mică.";
  return "";
}

/** The warning when a cohort with enrolments gets another trainer. */
export function trainerChangeNote(enrolled, before, after) {
  if (!enrolled || !before || before === after) return "";
  return `Grupa are deja ${enrolled === 1 ? "un înscris" : `${enrolled} înscriși`}, care au văzut pe site alt formator. `
    + "După salvare, cardul de pe site arată noul formator; dacă vrei să-i anunți, scrie-le separat.";
}
